import { AuthStatus, useAuthStatus } from 'scbk-services';

const AuthStatusSubscriber: React.FC = () => {
    const { useSubscribeStatus } = useAuthStatus();

    useSubscribeStatus(async (status) => {
        switch (status) {
            case AuthStatus.UNAUTHENTICATED:
                try {
                    //TODO: 추후 작업 필요
                    console.log('UNAUTHENTICATED');
                } catch (error) {
                    console.log('UNAUTHENTICATED, Polling Service Error', error);
                }
                break;

            case AuthStatus.PASSWORD_VERIFIED:
                //TODO: 추후 작업 필요
                console.log('PASSWORD_VERIFIED');
                break;
            case AuthStatus.LOGIN:
                console.log('LOGIN');
                break;
        }
    }, []);

    return null;
};

export { AuthStatusSubscriber };
